import {handleActions} from 'redux-actions';
import * as type from './actionTypes'
import {List} from './type';
const initState = {
    // payInfos: {
    //     ctplContractId: '',
    //     commContractId: '',
    //     comcode: '',
    //     productLine: '',
    //     phone: '',
    //     PaymentMethod: '',
    //     directJump: ''
    // }
    payInfos:null
}

const actions = {}

actions[type.FETCH_REPATINFO] = (state: List, action) => {
    console.log(actions);
    return{
        ...state,
        payInfos: action.payload.result
    }
}

export const reRepayInfo = handleActions(actions, initState)
